import type { AppLocale } from "@/shared/lib/appLocale";

/** Marketing / landing site (outside the SPA). */
export const LANDING_HOME_URL = "https://taroterra.com" as const;
export const LANDING_CONTACTS_URL = "https://taroterra.com/contacts/" as const;
export const LANDING_DAILY_CARD_URL = "https://taroterra.com/daily-card/" as const;
export const LANDING_PRIVACY_POLICY_URL = "https://taroterra.com/privacy-policy/" as const;

const LANDING_LOCALE_PREFIX: Record<AppLocale, string> = {
  en: "/en",
  ru: "/ru",
  ua: "",
};

function getLandingCatalogUrl(
  catalog: "rozklady-taro" | "karty-taro",
  locale: AppLocale,
): string {
  return `${LANDING_HOME_URL}${LANDING_LOCALE_PREFIX[locale]}/${catalog}/`;
}

export function getLandingHomeUrl(locale: AppLocale): string {
  const prefix = LANDING_LOCALE_PREFIX[locale];
  return prefix ? `${LANDING_HOME_URL}${prefix}/` : `${LANDING_HOME_URL}/`;
}

export function getLandingSpreadsCatalogUrl(locale: AppLocale): string {
  return getLandingCatalogUrl("rozklady-taro", locale);
}

export function getLandingCardsCatalogUrl(locale: AppLocale): string {
  return getLandingCatalogUrl("karty-taro", locale);
}

export function getLandingDailyCardUrl(slug: string): string {
  return `${LANDING_DAILY_CARD_URL}${slug}/`;
}
